export default "__VITE_ASSET__W1rqij9n__"